module.exports = __webpack_public_path__ + "static/media/yto.0ac58a50.svg";